import ContentPadding from "../ContentConfig/ContentPadding";
import { Form, Radio, Slider, Switch, Divider } from "antd";
import { AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined } from "@ant-design/icons";
import { ColorPickerFormItem, LinkInputFields } from "../Image/ImageConf";
import ContentID from "../Common/ContentID";

export default ({ node }) => {
  return (
    <>
      <LinkInputFields />

      <Divider />

      <div style={{ display: "flex", gap: 10, }}>
        <label>Auto width</label>
        <Form.Item  noStyle valuePropName="checked" name={"autoWidth"}>
          <Switch />
        </Form.Item>
      </div>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const auto = getFieldValue("autoWidth");
          if (!auto) {
            return (
              <Form.Item noStyle name="width">
                <Slider style={{width: "90%"}} min={20} max={100} marks={{ 20: "-", 100: "+" }} tipFormatter={(v) => `${v}%`} />
              </Form.Item>
            );
          }
          return null;
        }}
      </Form.Item>
      
      <div style={{height: 21}} />

      <ColorPickerFormItem
        label={"Background color"}
        name="backgroundColor"
        color={node.data.backgroundColor || { r: 0, g: 0, b: 0, a: 1 }}
      />

      <ColorPickerFormItem
        label={"Text color"}
        name="color"
        color={node.data.color || { r: 255, g: 255, b: 255, a: 1 }}
      />
      <Form.Item label="Alignment" name="align">
        <Radio.Group 
          style={{ margin: "12px 0 0 0" }}
          options={[
            { label: <AlignLeftOutlined />, value: 'left' },
            { label: <AlignCenterOutlined />, value: 'center' },
            { label: <AlignRightOutlined />, value: 'right' },
          ]}
          defaultValue="center"
          optionType="button"
        />
      </Form.Item>
      <Form.Item label={"Border radius"} name="borderRadius">
        <Slider style={{width: "90%"}} min={0} max={60} />
      </Form.Item>

      <Divider />
      <ContentID />
      <ContentPadding />

    </>
  );
};
